module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "c-page-matches u-pad-y-1"
  }, [(_vm.contentPage.list.length > 0) ? _c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  }, [_c('app-title', {
    staticClass: "c-big-title",
    attrs: {
      "logo": _vm.contentGlobal.secondaryLogo,
      "title": _vm.contentPage.title
    }
  }, [_c('app-btn', {
    staticClass: "u-valign-middle",
    on: {
      "click": function($event) {
        _vm.openModalRegister()
      }
    }
  }, [_c('span', {
    staticClass: "c-register-btn-icon__container u-inline-block"
  }, [_c('img', {
    staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-register--arrow.png")
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomy.support)
    }
  })])], 1), _vm._v(" "), _c('section', {
    staticClass: "u-fit-w u-flex--x u-flex--center u-align-center u-block@md u-marg-b-xxl@md"
  }, [_c('app-btn-filter', {
    staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md",
    class: [_vm.filterDay === 'upcoming' ? 'is-selected' : ''],
    on: {
      "click": function($event) {
        _vm._onFilterDateUpcoming()
      }
    }
  }, [_c('h2', {
    staticClass: "u-inline-block u-fit"
  }, [_vm._v("\n                    " + _vm._s(_vm.contentGlobal.taxonomies.matches.upcoming) + "\n                ")])]), _vm._v(" "), _c('app-btn-filter', {
    staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md u-marg-t-xs@md",
    class: [_vm.filterDay === 'today' ? 'is-selected' : ''],
    on: {
      "click": function($event) {
        _vm._onFilterDateToday()
      }
    }
  }, [_c('h2', {
    staticClass: "u-inline-block u-fit"
  }, [_vm._v("\n                    " + _vm._s(_vm.contentGlobal.taxonomies.matches.today) + "\n                ")])]), _vm._v(" "), _c('app-btn-filter', {
    staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md u-marg-t-xs@md",
    class: [_vm.filterDay === 'past' ? 'is-selected' : ''],
    on: {
      "click": function($event) {
        _vm._onFilterDatePast()
      }
    }
  }, [_c('h2', {
    staticClass: "u-inline-block u-fit"
  }, [_vm._v("\n                    " + _vm._s(_vm.contentGlobal.taxonomies.matches.past) + "\n                ")])])], 1), _vm._v(" "), _c('section', {
    staticClass: "u-relative u-marg-t-lg u-align-center c-matches-select u-vacuum u-marg-b-xxl"
  }, _vm._l((_vm.games), function(game, index) {
    return _c('div', {
      key: index,
      staticClass: "u-inline-block u-valign-middle u-w1of4 u-cursor-pointer c-matches-select__btn u-vacuum u-valign-top@md",
      class: [_vm.filterVideoGame.includes(index + 1) ? 'is-selected' : '', 'u-w1of' + (_vm.games.length + 1), 'u-w1of' + _vm.games.length + '@lg'],
      attrs: {
        "data-index": index + 1,
        "data-filter": _vm.filterVideoGame,
        "data-includes": _vm.filterVideoGame.includes(index + 1)
      },
      on: {
        "click": function($event) {
          _vm.toggleGame(index + 1)
        }
      }
    }, [_c('app-btn-radio', {
      staticClass: "u-inline-block u-valign-middle u-w1of5 u-fit-w@md u-marg-b-md@md",
      class: [_vm.filterVideoGame.includes(index + 1) ? 'is-selected' : '']
    }), _vm._v(" "), _c('div', {
      staticClass: "u-relative u-inline-block u-valign-middle u-w1of15 u-fit-w@md"
    }), _vm._v(" "), _c('div', {
      staticClass: "u-relative u-inline-block u-valign-middle u-w3of10 u-w4of10@lg u-block@md u-marg-x-auto@md u-w1of2@md u-w3of4@sm"
    }, [_c('img', {
      staticClass: "u-opacity--2 c-matches-select__btn__image u-force-3d u-fit-w",
      attrs: {
        "src": game.logo_light,
        "alt": game.name,
        "title": game.name
      }
    })])], 1)
  })), _vm._v(" "), (_vm.days.length > 0) ? _vm._l((_vm.days), function(list, index) {
    return _c('div', {
      staticClass: "u-marg-t-xxxl u-relative u-align-center"
    }, [_c('h3', {
      staticClass: "u-block u-color--red-pure u-uppercase t-text--bold t-lspacing--sm u-marg-t-xxl u-marg-b-lg"
    }, [_c('span', {
      staticClass: "u-block t-text--lg u-marg-b-xxxs",
      domProps: {
        "innerHTML": _vm._s(list.dateFormated[2])
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "u-block@md t-text--xxxl",
      domProps: {
        "innerHTML": _vm._s(list.dateFormated[0])
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "u-block@md t-text--xxxl",
      domProps: {
        "innerHTML": _vm._s(list.dateFormated[1])
      }
    })]), _vm._v(" "), _vm._l((list.matches), function(matches, gameId) {
      return [(matches.length > 0) ? [_c('div', {
        staticClass: "u-align-center"
      }, [_c('img', {
        staticClass: "u-marg-b-xl",
        attrs: {
          "src": _vm.getVideoGameFromID(matches[0].videoGameID).logo_dark,
          "width": "180"
        },
        on: {
          "load": _vm.load
        }
      })]), _vm._v(" "), _c('table', {
        staticClass: "u-fit-w u-marg-b-xxxl"
      }, [_c('tbody', [_vm._m(0, true), _vm._v(" "), _vm._l((matches), function(match, i) {
        return [_c('app-matches-table-tr', {
          key: match.id,
          class: {
            'c-team-profile__bg': (i % 2) === 1
          },
          attrs: {
            "match": match,
            "contentGlobal": _vm.contentGlobal,
            "contentPage": _vm.contentPage
          }
        }), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "c-player__bg-line u-height-1",
          attrs: {
            "colspan": "3"
          }
        })])]
      })], 2)])] : _vm._e()]
    })], 2)
  }) : _c('p', {
    staticClass: "u-align-center u-marg-t-xxxl u-marg-b-xxxl t-text--lg",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomy.empty.replace(':filter', _vm.filterDay))
    }
  })], 2) : _c('app-season-coming-soon', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "c-player__bg-line u-height-1",
    attrs: {
      "colspan": "3"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b6b36e"}!./src/scripts/components/page-matches/template.html
// module id = 935
// module chunks = 0